<app-navigation [tagline]="currentHeadline" [marginLeftClass]="currentMarginClass"></app-navigation>
<ion-content fullscreen>

  <swiper-container [spaceBetween]="100" #swiperContainer (swiperinit)="onSwiperInit($event)"
                    (swiperslidechange)="onSlideChange()"
  >
    <swiper-slide class=" ion-padding h-80
 ">
      <div>
        <app-intro-start></app-intro-start>
        <app-buttons (clickedNext)="next()" [showLastButton]="false"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding">
      <div>
        <app-how-to></app-how-to>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding">
      <div>
        <app-access-authority></app-access-authority>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding tipps">
      <div>
        <app-tipps [part]="1"></app-tipps>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding tipps">
      <div>
        <app-tipps [part]="2"></app-tipps>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding tipps">
      <div>
        <app-tipps [part]="3"></app-tipps>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding tipps">
      <div>
        <app-tipps [part]="4"></app-tipps>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
    <swiper-slide class="ion-padding compass">
      <div>
        <app-intro-check></app-intro-check>
        <app-buttons (clickedNext)="next()" (clickedLast)="last()" [showLastButton]="true"></app-buttons>
      </div>
    </swiper-slide>
  </swiper-container>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
